module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "editcase"
  }, [_c('mt-header', {
    staticClass: "worktitle",
    attrs: {
      "title": _vm.title
    }
  }, [_c('mt-button', {
    attrs: {
      "slot": "left",
      "icon": "back"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push("/addcase")
      }
    },
    slot: "left"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "infobody"
  }, [_c('div', {
    staticClass: "dataGroup"
  }, [_vm._m(0), _vm._v(" "), _c('van-field', {
    attrs: {
      "placeholder": "输入作品名称",
      "maxlength": "20"
    },
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", $$v)
      },
      expression: "form.title"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dataGroup"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "dataGroupdiv",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "placeholder": "",
      "input-align": "right"
    },
    on: {
      "click": _vm.typeShow
    },
    model: {
      value: (_vm.form.industryName),
      callback: function($$v) {
        _vm.$set(_vm.form, "industryName", $$v)
      },
      expression: "form.industryName"
    }
  }), _vm._v(" "), _c('van-icon', {
    attrs: {
      "name": "arrow"
    },
    on: {
      "click": _vm.typeShow
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dataGroup"
  }, [_vm._m(2), _vm._v(" "), _c('van-field', {
    attrs: {
      "placeholder": "输入您的职责",
      "maxlength": "20"
    },
    model: {
      value: (_vm.form.obligation),
      callback: function($$v) {
        _vm.$set(_vm.form, "obligation", $$v)
      },
      expression: "form.obligation"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "edit"
  }, [_vm._m(3), _vm._v(" "), _vm._l((_vm.imgurl), function(imgurl, index) {
    return _c('div', {
      key: index,
      staticClass: "imgs"
    }, [_c('icon', {
      attrs: {
        "name": "times-circle"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.deleteWorksPhoto(imgurl.resId, imgurl.workPhotoId)
        }
      }
    }), _vm._v(" "), _c('img', {
      attrs: {
        "src": _vm.httpUrl + imgurl.resAddr
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.imgurl.length < 5),
      expression: "imgurl.length<5"
    }],
    staticClass: "addImg",
    on: {
      "click": _vm.upImg
    }
  }, [_c('van-icon', {
    attrs: {
      "name": "plus"
    }
  }), _vm._v(" "), _c('p', [_vm._v("点击上传")])], 1), _vm._v(" "), _c('input', {
    ref: "upDataPart",
    attrs: {
      "id": "upDataPart",
      "type": "file",
      "accept": "image/*",
      "value": "上传",
      "enctype": "multipart/form-data"
    },
    on: {
      "change": function($event) {
        return _vm.onFormChange($event)
      }
    }
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "descrition"
  }, [_vm._m(4), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.description),
      expression: "form.description"
    }],
    attrs: {
      "id": "desc",
      "maxlength": "500",
      "placeholder": "输入作品描述"
    },
    domProps: {
      "value": (_vm.form.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dataGroup",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('p', [_vm._v("作品链接")]), _vm._v(" "), _c('van-field', {
    attrs: {
      "placeholder": "输入作品链接",
      "maxlength": "250"
    },
    model: {
      value: (_vm.form.link),
      callback: function($$v) {
        _vm.$set(_vm.form, "link", $$v)
      },
      expression: "form.link"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "57px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "next"
  }, [_c('van-button', {
    staticClass: "delete",
    attrs: {
      "type": "info"
    },
    on: {
      "click": function($event) {
        return _vm.deleteAccountWorks(_vm.form.workId)
      }
    }
  }, [_vm._v("删除")]), _vm._v(" "), _c('van-button', {
    directives: [{
      name: "preventReClick",
      rawName: "v-preventReClick"
    }],
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")])], 1), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.pickDuty),
      callback: function($$v) {
        _vm.pickDuty = $$v
      },
      expression: "pickDuty"
    }
  }, [_c('van-picker', {
    attrs: {
      "show-toolbar": "",
      "columns": _vm.workduty
    },
    on: {
      "confirm": _vm.ondutyConfirm,
      "cancel": function($event) {
        _vm.pickDuty = false
      }
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("作品名称"), _c('span', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("所属行业"), _c('span', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("工作职责"), _c('span', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "name"
  }, [_vm._v("作品图片"), _c('span', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("作品描述"), _c('span', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("*")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b46b245","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/my/editcase.vue
// module id = 1279
// module chunks = 1